import React, { useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { decodeJWT, setToken } from "../utilities/authHelper";
import { resolveEmbedRoute } from "./embedRoutes";

// Landing route for partner launch URLs: /embed-login/<token>?embed=<key>&instrument=<PAIR>.
// Exchanges the single-use token for a session, then opens the embed screen.
const EmbedLogin = () => {
  const { loginToken } = useParams();
  const { search } = useLocation();
  const [status, setStatus] = useState("Signing in...");
  const started = useRef(false); // the token is single-use; React StrictMode runs effects twice in dev

  useEffect(() => {
    const target = resolveEmbedRoute(
      new URLSearchParams(search).get("embed"),
      search,
    );
    if (!loginToken || !target) {
      setStatus("Invalid launch link.");
      return;
    }
    if (started.current) return;
    started.current = true;

    const exchange = async () => {
      try {
        const apiUrl = process.env.REACT_APP_API_URL;
        const response = await fetch(
          `${apiUrl}/sso/login?token=${encodeURIComponent(loginToken)}`,
        );
        const data = await response.json().catch(() => ({}));
        const accessToken = data?.results?.access_token;
        if (!response.ok || !accessToken) {
          setStatus("Login failed. Please reopen this screen from your desktop.");
          return;
        }
        const payload = decodeJWT(accessToken);
        setToken(accessToken, data.results.user_id, data.results.role, payload.account_id);
        window.location.replace(target);
      } catch {
        setStatus("Login failed. Please reopen this screen from your desktop.");
      }
    };

    exchange();
  }, [loginToken, search]);

  return <div className="p-4" style={{ fontFamily: "sans-serif" }}>{status}</div>;
};

export default EmbedLogin;
